// @ts-nocheck
import {useState, useRef, useEffect} from 'react';
import {getIntersectionObserverInstance} from '@stencil/intersection-observer';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt?: string;
  fallback?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  itemProp?: string;
  onError?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
  onImageLoad?: () => void;
  htmlAttributes?: React.HTMLAttributes<HTMLImageElement>;
  defaultImagePlaceholder?: string;
}

const Image = (props: ImageProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const {
    src,
    alt = '',
    fallback = '',
    className,
    style = {},
    onClick = () => {},
    itemProp = '',
    onError = () => {},
    onImageLoad = () => {},
    htmlAttributes = {},
    defaultImagePlaceholder = 'https://gos3.ibcdn.com/default-4-1426763954.png',
    ...restProps // Spread all remaining props (like `data-nosnippet`)
  } = props;
  const sourceRef = useRef();
  const [error, setError] = useState(false);

  // const imagePlaceholder =
  //   'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  const imagePlaceholder = defaultImagePlaceholder;

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.01,
  };

  let observer = '';
  const IntersectionObserver = getIntersectionObserverInstance();

  useEffect(() => {
    if (IntersectionObserver) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          // if element is intersecting as per threshold set, then update state and remove observer
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect(entry.target);
          }
        });
      }, options);
    }

    if (observer) observer.observe(sourceRef.current);

    return () => {
      if (observer && observer.current) observer.current.disconnect();
    };
  }, []);

  if (error) {
    return <img ref={sourceRef} {...props} src={fallback} alt={alt} />;
  }

  const conditionalProps = {};
  if (itemProp) {
    conditionalProps['itemProp'] = itemProp;
  }

  return (
    <img
      ref={sourceRef}
      src={IntersectionObserver ? (isVisible ? src : imagePlaceholder) : src}
      alt={alt}
      className={className}
      // data-src={src}
      onError={e => {
        onError(e);
        setError(true);
      }}
      onLoad={onImageLoad}
      data-testid={props['data-testid'] || ''}
      style={{...style}}
      onClick={onClick}
      {...conditionalProps}
      {...htmlAttributes}
      {...restProps}
    />
  );
};

export default Image;
